export const REDUCER_REMOVE_NOTIFICATION = 'REDUCER_REMOVE_NOTIFICATION';

export const RemoveNotification = (message: string) => ({
  type: REDUCER_REMOVE_NOTIFICATION,
  data: {
    message,
  },
});
